{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Board or Shareholder Resolution",
  "description": "A resolution passed by the directors or shareholders of a company.",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "company": { "$ref": "#/definitions/company" },
    "resolution": { "$ref": "#/definitions/resolution" }
  },
  "additionalProperties": false
}
